<template>
  <div data-component-group="filter-forms" class="tracking-networks-filters">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Network name"
        prepend-inner-icon="search"
        hide-details
      />
    </FiltersForm>
  </div>
</template>

<script>
  import stringEscape from 'js-string-escape';
  import FiltersForm from './FiltersBase';
  import { isNonEmptyStr, isNonEmptyArr, isNull } from '@/utils';

  export default {
    components: {
      FiltersForm,
    },
    emits: ['filter', 'clearFilters'],
    data() {
      return {
        search: null,
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries } = this;
        return isNonEmptyStr(search) || isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onFilter() {
        const formattedSearch = isNull(this.search) ? '' : stringEscape(this.search);

        this.$emit('filter', {
          search: formattedSearch,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];

        this.$emit('clearFilters');
      },
    },
  };
</script>
